import { Navigate, useLocation } from 'react-router-dom';
import { getAuthData } from '../../utils/auth';

interface AuthGuardProps {
  children: React.ReactNode;
  allowedRoles?: ('admin' | 'user')[];
}

const isRole = (role: any): role is 'admin' | 'user' => {
  return role === 'admin' || role === 'user';
};

const AuthGuard: React.FC<AuthGuardProps> = ({ children, allowedRoles = ['admin', 'user'] }) => {
  const { accessToken, role } = getAuthData();
  const location = useLocation();

  const userRole = localStorage.getItem('role');

  if (!accessToken && userRole === 'user') {
    return <Navigate to="/user/login" replace state={{ from: location }} />;
  } else if (!accessToken && userRole === 'admin') {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  } else if (!accessToken && !userRole) {
    return <Navigate to="/user/login" replace state={{ from: location }} />;
  }
  if ((!isRole(role) || !allowedRoles.includes(role)) && accessToken) {
    // Check if role is valid and allowed
    const basePath = role === 'admin' ? '/dashboard' : '/user/dashboard';

    // Special case: redirect from root path to appropriate dashboard
    if (location.pathname === '/') {
      return <Navigate to={basePath} replace />;
    }

    // Block unauthorized access - redirect to user's appropriate dashboard
    return <Navigate to={basePath} replace />;
  }

  // Additional check for root path with valid role
  if (location.pathname === '/') {
    const basePath = role === 'admin' ? '/dashboard' : '/user/dashboard';
    return <Navigate to={basePath} replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
